import { FontSize } from '@usacsmideo/types';

export const FontSizeController = (props: FontSize) => {
  const min = props.min ?? 12;
  const max = props.max ?? 60;

  return (
    <div className="my-2 grid w-full grid-cols-[auto_1fr_auto] items-center gap-4">
      <button
        id="smaller-text"
        onClick={() => {
          props.setTextSize(Math.max(min, props.textSize - 2));
        }}
        className="text-left"
        aria-label="Decrease text size"
      >
        Smaller
      </button>
      <input
        type="range"
        min={min}
        max={max}
        value={props.textSize}
        className="slider"
        id="text-size-slider"
        onChange={(e) => props.setTextSize(parseInt(e.target.value))}
        disabled={props.scrolling}
        aria-label="Adjust text size"
        aria-valuetext={`Font size: ${props.textSize} pixels`}
      />
      <button
        id="bigger-text"
        onClick={() => {
          props.setTextSize(Math.min(max, props.textSize + 4));
        }}
        className="text-right"
        aria-label="Increase text size"
      >
        Bigger
      </button>
    </div>
  );
};
